import { render, staticRenderFns } from "./moban.vue?vue&type=template&id=9f83e514&scoped=true"
import script from "./moban.vue?vue&type=script&lang=js"
export * from "./moban.vue?vue&type=script&lang=js"
import style0 from "./moban.vue?vue&type=style&index=0&id=9f83e514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f83e514",
  null
  
)

export default component.exports